import {autoserializeAs} from "dcerialize";

export class ServerImageSize {
  @autoserializeAs(() => Number)
  public readonly width: number;
  @autoserializeAs(() => Number)
  public readonly height: number;
}

export class ServerImage {
  @autoserializeAs(() => String)
  public readonly source: string; // URL
  @autoserializeAs(() => ServerImageSize)
  public readonly size: ServerImageSize;
}
